// import React from 'react'
// import { useEffect, useState } from 'react'
// import { Link } from 'react-router-dom'
// import './side.css'

// const Side = () => {

//     const clickOnLink =(e)=>{
//         const elements = document.querySelectorAll(".side a");
//         elements.forEach(element => {
//           element.classList.remove("active");
//         });
    
//         sessionStorage.setItem("active",e.target.innerHTML)
//         e.target.classList.add("active")
        
//         }

//         useEffect(()=>{
//             if(sessionStorage.getItem("active")){
//               document.querySelectorAll(".nav .list a").forEach(element=>{
//                 if(element.innerHTML === sessionStorage.getItem("active")){
//                   element.classList.add("active")
//                 }
//               })
//             }
//             },[])
//   return (
//  <div className="side">
// <Link onClick={clickOnLink} to="/main-page">الرئيسية</Link>
// <Link onClick={clickOnLink} to="/account">معلومات الحساب</Link>
// <Link onClick={clickOnLink} to="/my-team">فريقي</Link>
// <Link onClick={clickOnLink} to="/transfer">تحويل المكافأة</Link>
// <Link onClick={clickOnLink} to={"/trans"}>السجلات المالية</Link>
// <Link onClick={clickOnLink} to={"/week"}>التسجيلات الاسبوعية</Link>
// <Link onClick={clickOnLink} to="/change-pocket">كلمة سر الخزنة</Link>
// <Link onClick={clickOnLink} to="/change-password">تغيير كلمة المرور</Link>

//  </div>
//   )
// }

// export default Side
import React from "react";
import {NavLink  } from "react-router-dom";
import "./side.scss";

const Side = () => {
  const links = [
    { to: "/main-page", label: "الرئيسية" },
    { to: "/account", label: "معلومات الحساب" },
    { to: "/my-team", label: "فريقي" },
    { to: "/transfer", label: "تحويل المكافأة" },
    { to: "/trans", label: "السجلات المالية" },
    { to: "/week", label: "التسجيلات الاسبوعية" },
    { to: "/change-pocket", label: "كلمة سر الخزنة" },
    { to: "/change-password", label: "تغيير كلمة المرور" },
  ];

  return (
    <aside className="side">
      {links.map((link) => (
        <NavLink
          key={link.to}
          to={link.to}
          className={({ isActive }) =>
            isActive ? "side-link active" : "side-link"
          }
        >
          <span>{link.label}</span>
        </NavLink>
      ))}
    </aside>
  );
};

export default Side;
